import React from "react";
import { UpdateCartData } from "@cart-client/interfaces/Checkout";
import { ApiResponse } from "@cart-client/interfaces/Api";
import { ReviewedCartApiResponse } from "@swiggy-private/cart-types";
import { FlowType, CouponPageType } from "@swiggy-private/checkout-core";
import { SyncApplyCouponCartParams } from "@cart-client/interfaces/Coupon";

export interface UpdateCartContextValue {
    updateCartInProgress: boolean;
    updateCartData?: UpdateCartData | null;
    updateCartError?: { httpStatusCode?: number };
    doUpdateCart: (
        data: NonNullable<UpdateCartData>,
    ) => Promise<ApiResponse<ReviewedCartApiResponse> | null | undefined>;
    reloadCart: () => void;
    performApplyCoupon: () => Promise<void>;
    performRemoveCoupon: () => Promise<void>;
    syncApplyCouponCart: (params: SyncApplyCouponCartParams) => void;
    toggleCouponModal: VoidFunction;
    togglingDelightPopup: VoidFunction;
    showCouponModal: boolean;
    showDelightPopup: boolean;
    showFreebiePopup?: boolean;
    setShowFreebiePopup?: React.Dispatch<React.SetStateAction<boolean>>;
    handleCouponListingPageCouponRemove: (subpage?: CouponPageType, couponCode?: string) => void;
    showM2Chalfcard?: boolean;
    setShowM2Chalfcard?: React.Dispatch<React.SetStateAction<boolean>>;
    showM2ChalfcardOnClick?: {
        status: boolean;
        flowType: FlowType; // for analytics and subscriptionNudgeInitiator header
    };
    setShowM2ChalfcardOnClick: React.Dispatch<React.SetStateAction<{ status: boolean; flowType: FlowType }>>;
    showPendingDiscountingComms: () => void;
}

export const UpdateCartContext = React.createContext<UpdateCartContextValue>({
    updateCartInProgress: false,
    doUpdateCart: async () => null,
    reloadCart: () => void 0,
    showCouponModal: false,
    showDelightPopup: false,
    toggleCouponModal: () => void 0,
    performRemoveCoupon: () => Promise.resolve(void 0),
    performApplyCoupon: () => Promise.resolve(void 0),
    syncApplyCouponCart: () => void 0,
    togglingDelightPopup: () => void 0,
    handleCouponListingPageCouponRemove: () => void 0,
    showM2Chalfcard: false,
    setShowM2Chalfcard: () => void 0,
    showM2ChalfcardOnClick: {
        status: false,
        flowType: FlowType.M2C,
    },
    setShowM2ChalfcardOnClick: () => void 0,
    showPendingDiscountingComms: () => void 0,
    showFreebiePopup: false,
    setShowFreebiePopup: () => void 0,
});

if (__DEV__) {
    UpdateCartContext.displayName = "UpdateCartContext";
}
